import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { DateModel } from "@sonic/CustomComponents/CustomMobiusComponenets/AvailableToPromise/AvailableToPromiseService";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
    currentLocation: getLocation(state),
});

export interface CartApproverMessageStyles {
    approvingText?: TypographyPresentationProps;
    approvingWrapper?: InjectableCss;
    errorWrapper?: InjectableCss;
    statusErrorText?: TypographyPresentationProps;
}

export const cartApproverMessageStyles: CartApproverMessageStyles = {
    approvingWrapper: {
        css: css`
            text-align: center;
            padding: 10px;
            background-color: ${getColor("info.main")};
        `,
    },
    approvingText: {
        css: css`
            width: 100%;
        `,
    },
    errorWrapper: {
        css: css`
            text-align: center;
            padding: 10px;
            background-color: ${getColor("common.background")};
            box-shadow: 0 6px 25px rgb(0 0 0 / 20%);
            border-radius: 6px;
        `,
    },
    statusErrorText: {
        size: 14,
        color: "danger",
        css: css`
            margin-top: 10px;
        `,
        weight: 600,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = cartApproverMessageStyles;
const CartApproverMessage = ({ cart, currentLocation }: Props) => {
    if (!cart || !cart.isAwaitingApproval || cart.cartLines?.length === 0) {
        const [availableDates, setAvailableDates] = React.useState<DateModel[]>([]);
        const [errorMessage, setErrorMessage] = React.useState<string>("Loading delivery dates");
        const [loading, setLoading] = React.useState(true);
        const isCheckOutPage = currentLocation.pathname === "/CheckoutReviewAndSubmit";

        // GG: disable this because we do not need it any more.. for now...

        return null;
    }

    return null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CartApproverMessage),
    definition: {
        displayName: "Cart Approver Message",
        icon: "cart-circle-check",
        group: "Common",
    },
};

export default widgetModule;
